<template>
  <div class="row">
    <div class="col-12">
      <q-tabs v-if="data" v-model="tab">
        <q-tab name="general" label="General" />
        <q-tab name="surveys" label="Surveys" />
      </q-tabs>
    </div>
    <div v-if="tab == 'general'" class="col-12">
      <q-form ref="form" class="full-width q-pa-md">
        <div class="row items-center">
          <div class="col-12 q-px-sm">
            <q-input
              v-model="formData.name"
              label="Organisation Name"
              :rules="[(v) => !!v || 'Name is Required']"
            ></q-input>
          </div>
          <div class="col-12 q-px-sm">
            <places-autocomplete
              ref="googleAutoComplete"
              label="Business location"
              :selectedPlace="formData.location"
              @placeSelected="placeSelected"
            ></places-autocomplete>
          </div>
          <div class="col-12 col-md-6 q-px-sm">
            <q-input
              v-model="formData.keyPersonName"
              label="Key Person Name"
            ></q-input>
          </div>

          <div class="col-12 col-md-6 q-px-sm">
            <q-input
              v-model="formData.keyPersonPhone"
              label="Key Person Phone"
            ></q-input>
          </div>
          <div class="col-12 q-px-sm">
            <q-input
              v-model="formData.keyPersonEmail"
              label="Key Person Email"
            ></q-input>
          </div>
          <!-- Button to run an API Call to export ALL surveys -->
          <div class="col-12 q-pa-sm">
            <q-btn
              @click="exportSurveys"
              class="full-width"
              color="primary"
              :loading="exportingSurveys"
            >
              <q-icon name="mdi-download"></q-icon> Export Surveys
            </q-btn>
          </div>
        </div>
      </q-form>
    </div>
    <div v-if="tab == 'surveys'" class="col-12">
      <div class="row">
        <div class="col-12">
          <h6 class="q-my-sm">Organisation Surveys</h6>
        </div>
        <div class="col-12">
          <assignSurvey
            @id="addSurveyID"
            @changed="(val) => (addSurveyID = val)"
          />
          <q-btn
            flat
            @click="addSurvey"
            class="full-width"
            :disable="!addSurveyID"
            :loading="addSurveyLoading"
          >
            <q-icon name="mdi-plus"></q-icon> Add Survey
          </q-btn>
        </div>
        <div class="col-12" style="height: 300px !important">
          <div style="height: 5px">
            <q-linear-progress
              indeterminate
              v-if="organizationsSurveysLoading"
            />
          </div>
          <datatable
            :filter="search"
            :flat="true"
            :data="organizationsSurveys"
            :columns="columns"
            @rowSelected="handleDoubleClick"
            @rowDoubleClick="handleDoubleClick"
          >
            <template slot="body-cell-name" slot-scope="data">
              <q-td :props="data.props">
                {{ data.props.row.name }}
                <q-tooltip>{{ data.props.row.name }}</q-tooltip>
              </q-td>
            </template>
            <template slot="body-cell-location" slot-scope="data">
              <q-td :props="data.props">
                {{ data.props.row.location }}
                <q-tooltip>{{ data.props.row.location }}</q-tooltip>
              </q-td>
            </template>
            <template slot="body-cell-actions" slot-scope="data">
              <q-td :props="data.props">
                <q-btn
                  :loading="removingSurveyID == data.props.row.id"
                  @click="removeSurvey(data.props.row.id)"
                  round
                  flat
                  color="secondary"
                >
                  <q-icon name="mdi-delete"></q-icon>
                </q-btn>
              </q-td>
            </template>
          </datatable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import placesAutocomplete from "@/components/googleMaps/placesAutocomplete.vue";
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import assignSurvey from "@/components/scheduledSurveys/assignSurvey.vue";
import moment from "moment";

export default {
  components: {
    placesAutocomplete,
    datatable,
    assignSurvey,
  },
  computed: {
    ...mapGetters(["organizationsSurveys", "organizationsSurveysLoading"]),
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  watch: {
    data: function () {
      this.init();
    },
  },
  data: () => ({
    // Extra Data
    formData: {},
    tab: "general",
    search: "",
    addSurveyID: null,
    addSurveyLoading: false,
    removingSurveyID: null,
    columns: [
      {
        name: "name",
        label: "Name",
        align: "left",
        field: "name",
        sortable: true,
      },
      {
        name: "date",
        label: "Date",
        align: "left",
        field: "date",
        format: (val) => (val != null ? moment(val).format("DD/MMM/YYYY") : ""),
        sortable: true,
      },
      {
        name: "location",
        label: "Location",
        align: "left",
        field: "location",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true,
      },
      {
        name: "actions",
        label: "Actions",
        align: "left",
        field: "actions",
        sortable: true,
      },
    ],

    exportingSurveys: false,
  }),
  mounted() {
    setTimeout(() => {
      this.init();
    }, 100);
  },
  methods: {
    init() {
      if (this.data != null) {
        this.formData = JSON.parse(JSON.stringify(this.data));
        this.$store.dispatch("loadOrganizationsSurveys", this.data.id);
      } else {
        this.formData = {};
      }
    },
    create() {
      this.$emit("loadingStateChanged", true);
      setTimeout(() => {
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.$store
              .dispatch("newOrganization", this.formData)
              .then((result) => {
                this.$emit("loadingStateChanged", false);
                if (result.Result == "Success") {
                  this.$emit("close", true);
                  this.formData = {};
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: result.Response.Message,
                  });
                }
              });
          } else {
            this.$emit("loadingStateChanged", false);
          }
        });
      }, 200);
    },
    save() {
      this.$emit("loadingStateChanged", true);
      setTimeout(() => {
        this.$store
          .dispatch("saveOrganization", this.formData)
          .then((result) => {
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              this.address = "";
              this.$emit("close", true);
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: "Organisation has been saved",
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      });
    },
    placeSelected(place) {
      this.formData.location = place.formatted_address;
      this.formData.locationJSON = JSON.stringify(place);
    },
    handleDoubleClick(row) {},
    addSurvey() {
      this.addSurveyLoading = true;
      this.$store
        .dispatch("organizationAddSurvey", {
          organizations_id: this.data.id,
          surveys_id: this.addSurveyID,
        })
        .then((result) => {
          this.addSurveyLoading = false;
          if (result.Result == "Success") {
            this.addSurveyID = null;
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: "Survey hass been added to Organisation",
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        });
    },
    removeSurvey(id) {
      this.removingSurveyID = id;
      this.$store
        .dispatch("organizationRemoveSurvey", {
          organizations_id: this.data.id,
          surveys_id: id,
        })
        .then((result) => {
          this.removingSurveyID = null;
          if (result.Result == "Success") {
            this.addSurveyID = null;
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: "Survey hass been removed from the Organisation",
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        });
    },

    // Function to run organizationExportSurveyBatch
    async exportSurveys() {
      this.exportingSurveys = true;
      try {
        const response = await this.$store.dispatch(
          "organizationExportSurveyBatch",
          {
            organizations_id: this.data.id,
          }
        );
        if (response.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: response.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
      this.exportingSurveys = false;
    },
  },
};
</script>
